import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'auto-editor-edit-input',
  templateUrl: './edit-input.component.html',
  styleUrl: './edit-input.component.scss',
  standalone: false
})
export class EditInputComponent {
  editMode: boolean;
  @Input() name: string;
  @Input() original: string;
  @Input() duplicated: boolean;
  @Output() next: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  emitNewName() {
    if (this.name.trim() !== '') {
      this.next.emit(this.name);
      this.editMode = false;
    }
  }

  emitCancel() {
    this.name = this.original;
    this.editMode = false;
  }
}
